// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_PlanRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_PlanRow — a single subscription plan row.
 *
 * Mirrors SubscriptionPlanWithPriceRow phpstan-type from subscription_plans_model
 * (joined to subscription_plan_prices for live pricing data).
 *
 * price_cents / currency / provider_code / provider_price_ref / countries are
 * nullable: a plan that has no live price rows yet (market-less, created via the
 * plan-only flow) returns NULL for all price fields and an empty array for countries.
 * The staff list (GET /subscriptions/plans) uses the LEFT JOIN variant and surfaces
 * these rows so staff can add a first market via POST /prices.
 *
 * currency: ISO 4217 code from the live price row (e.g. 'BRL', 'USD', 'CLP'),
 * or null for a market-less plan. The 'BRL' default has been removed — a row
 * that genuinely has no price must not claim a currency.
 *
 * provider_code: the AUTHORITATIVE charge route for this price row (e.g. 'gatewaytest',
 * 'stripe'). Null only for market-less plans (no live price row yet).
 *
 * countries: ISO 3166-1 alpha-2 codes from subscription_plan_price_countries
 * for the live price row. Empty array for market-less plans.
 */
import { registerContract } from './validate'

export interface Subscriptions_PlanRow {
id: number
name: string
cycle: string
monthly_credit_grant: number
active: number
price_cents?: number
currency?: string
provider_code?: string
provider_price_ref?: string
stripe_price_id?: string
superseded_by?: number
created_at?: string
updated_at?: string
countries?: string[]
}

registerContract('Subscriptions_PlanRow', {
  id:                   { type: 'number',  required: true },
  name:                 { type: 'string',  required: true },
  cycle:                { type: 'string',  required: true },
  monthly_credit_grant: { type: 'number',  required: true },
  active:               { type: 'number',  required: true },
  price_cents:          { type: 'number',  required: false },
  currency:             { type: 'string',  required: false },
  provider_code:        { type: 'string',  required: false },
  provider_price_ref:   { type: 'string',  required: false },
  stripe_price_id:      { type: 'string',  required: false },
  superseded_by:        { type: 'number',  required: false },
  created_at:           { type: 'string',  required: false },
  updated_at:           { type: 'string',  required: false },
  countries:            { type: 'array',   required: false },
})
